export const SHARED_THEMED_ROUTES = new Set(['project-components', 'project-pages']);

export const BUSINESS_PROJECT_THEMED_ROUTES = new Set([
	...[
		'classic-business-approvals',
		'classic-business-overview-calendar',
		'classic-business-sample-onboarding',
		'classic-business-form-submit',
		'classic-business-reports-overview',
		'classic-business-overview-summary',
		'classic-business-view-not-found',
		'classic-business-form-submit-public',
		'classic-business-shortcut',
		'classic-business-form-builder',
		'classic-business-form',
		'classic-business-timeline',
		'classic-business-attachments',
		'classic-business-overview-redirect',
		'classic-business-redirect',
		'classic-business-list',
		'classic-business-board',
		'classic-business-calendar',
		'classic-business-overview-timeline',
		'classic-business-summary',
		'issue-navigator-core',
		'classic-business-archived-work-items',
	],
	...SHARED_THEMED_ROUTES,
]);
